import { Flex, Text, useMantineTheme } from "@mantine/core";
import { useState } from "react";
import { BadgeInstruments } from "../Badge";
import { AddCircle } from "iconsax-react";
import { IColor } from "../../utils/selectColors";
import { useTranslation } from "react-i18next";
import InstrumentsModal from "./InstrumentsModal";
import CardBoxShadow from "../Cards/CardBoxShadow";
import { IProduct } from "../../interfaces/Products/IProductDetail";
import { useMediaQuery } from "@mantine/hooks";

type IProps = {
  product?: IProduct | undefined;
};

export default function InstrumentsNew({ product }: IProps) {
  const theme = useMantineTheme();
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const instruments = product?.instruments?.symbols;
  const idProduct = product?.id;
  const isCripto = product?.market === "CRIPTO";
  const disabled = !instruments || instruments.length === 0;

  return (
    <>
      {open ? (
        <InstrumentsModal
          idProduct={idProduct}
          isOpen={open}
          onClose={() => setOpen(false)}
          isCripto={isCripto}
        />
      ) : null}
      <CardBoxShadow disabled={disabled}>
        <Flex
          w="100%"
          h="100%"
          justify={"space-between"}
          direction={"column"}
          p="16px"
          gap="16px"
        >
          <Flex gap="20px" align={"center"}>
            <Text
              color={theme.colors.basic[4]}
              fz={"14px"}
              fw={500}
              style={{ whiteSpace: "nowrap" }}
              ff={"barlow"}
              h="22px"
            >
              {isCripto
                ? t("global.instruments.label_crypto")
                : t("global.instruments.label")}
            </Text>
            <Flex
              onClick={() => (disabled ? null : setOpen(true))}
              style={{
                cursor: disabled ? "default" : "pointer",
              }}
              align={"center"}
              gap={"8px"}
              h="24px"
            >
              <Text
                color={theme.colors.basic[5]}
                fz={"14px"}
                fw={700}
                style={{ whiteSpace: "nowrap" }}
                ff={"barlow"}
                h="22px"
              >
                {t("global.brokersCards.see_all")}
              </Text>
              <AddCircle size={24} color={theme.colors.basic[5]} />
            </Flex>
          </Flex>
          {!!instruments && instruments?.length > 0 ? (
            <Flex
              style={{ overflow: "hidden" }}
              pos={"relative"}
              w="100%"
              mih="40px"
              align={"center"}
              gap={"24px"}
            >
              <Flex gap={"24px"} align={"center"} pos="absolute">
                {instruments.map((instrument, index: number) => {
                  return index < 3 ? (
                    <BadgeInstruments
                      key={`${instrument}${index}`}
                      badgeColor={IColor.instruments}
                      badgeName={`${instrument}`}
                    />
                  ) : null;
                })}
              </Flex>
            </Flex>
          ) : (
            <Text color="basic.4" fw={400} size={14}>
              {isCripto
                ? t("global.instruments.no_data_crypto")
                : t("global.instruments.no_data")}
            </Text>
          )}
        </Flex>
      </CardBoxShadow>
    </>
  );
}
